export default () => ({
  entities: [],
  isLoading: false,
  isError: false,
  selectedEntities: null,
  trashbin: [],
});
